import * as React from 'react'
interface MyProps {
    value_label:string
    value_count:number
}

type MyState = {
}
class BlockCounter extends React.PureComponent<MyProps,MyState> {
    render(){
	let count = this.props.value_count
	let lab = this.props.value_label
	let afgerond = false
	let cls = ""
	if(count > 0 && lab !== undefined){
	    if(lab.includes("afgerond")){
		cls = "checked"
		afgerond = true
	    }
       	}

	//let afg = afgerond ? "step-completed" : "step-incomplete"
	let counter = (
	    <span className="cf-count-btn">{count}</span>
	)
	if(afgerond){
	    counter = (
		<span className="cf-count-btn step-completed cf-icon-btn"><i className="bb-icon-l bb-icon-check"/></span>
	    )
	}

	return counter
    }
}


export default BlockCounter




